import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jphqn2suc: FaireProductEntity = {
  token: "p_5jphqn2suc",
  type: "product",
  name: "Rainbow Moonstone Worry Stones",
  brandToken: "b_eqykpyrhjx",
  brandName: "The Healing Sanctuary",
  imageUrl:
    "https://cdn.faire.com/fastly/abd87e64fc523e87f1d2eb37f00498fb5973d34880d0196a8a4069f8af311825.jpeg",
  galleryImageUrls: [],
  priceDollars: 1,
  description:
    "You will receive 1 worry stone\n\nSpiritually, amethyst facilitates meditation and communication with one's guides and angels. It opens and clears the third eye and Crown chakras, which in turn accelerates the development of intuitive and psychic abilities.\n\nEmotionally amethyst can help one identify the root causes behind behaviors and emotional patterns which create imbalance and disease. Amethyst is helpful for those who do not feel that they are native to the Earth plane, or who experience a constant longing for a home in other dimensions.\n\nAffirmation: I am purified, uplifted and protected through my connection with the divine.\n\n**Each and every crystal shipped from us is blessed with Reiki Love.\n\n*Crystals comes from Mother Earth, there will be slight variations for each stone, color, size, shape, etc. All metaphysical information given by The Healing Sanctuary is for spiritual purposes only.\n\n\n\n",
  tags: [],
  msrpDollars: 2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:09.214Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
